import React from 'react'
import {
  AdvcashSVG,
  AmericanExpressSVG,
  ApplePaySVG,
  BpaySVG,
  CreditCardSVG,
  GPaySVG,
  MasterCardSVG,
  NetellerOptionIcon,
  RapidOptionIcon,
  SkrillOptionIcon,
  UnionPaySVG,
  VISASVG,
} from '~/_metronic/helpers/components/svgs'
import {PaymentMethodConfig} from './types'

/**
 * Static registry of all active payment methods.
 * Order here = display order in the UI.
 *
 * Removed methods (not in registry):
 * - airwallex_cc (Amex/UnionPay) — Airwallex discontinued
 * - airwallex_giropay — Airwallex discontinued
 * - airwallex_eps — Airwallex discontinued
 * - coinbase — Discontinued, BPay replaces as crypto
 */
export const PAYMENT_METHODS: PaymentMethodConfig[] = [
  // 1. Credit Card (grouped: cardinity OR skrill_cc)
  {
    id: 'creditcard_2',
    settingsKey: null,
    settingsKeys: ['cardinity', 'skrill_cc'],
    label: 'Credit Card | Instant',
    subtitle: null,
    subtitleRenderer: () => (
      <div className='flex gap-2'>
        <VISASVG /> <MasterCardSVG />
      </div>
    ),
    icon: CreditCardSVG,
  },

  // 2. Other Cards — Amex, UnionPay, JCB (Stripe only, not supported by Cardinity)
  {
    id: 'stripe_other_cards',
    settingsKey: 'stripe_other_cards',
    label: 'Amex / UnionPay / JCB | Instant',
    subtitle: null,
    subtitleRenderer: () => (
      <div className='flex gap-2'>
        <AmericanExpressSVG /> <UnionPaySVG />
      </div>
    ),
    icon: CreditCardSVG,
  },

  // 3. Google Pay (via Nomupay or Stripe, settings key still named airwallex_googlepay)
  {
    id: 'airwallex_googlepay',
    settingsKey: 'airwallex_googlepay',
    label: 'Google Pay | Instant',
    subtitle: 'Pay using Google Pay',
    icon: GPaySVG,
  },

  // 4. Apple Pay (via Nomupay or Stripe, Safari only)
  {
    id: 'airwallex_applepay',
    settingsKey: 'airwallex_applepay',
    label: 'Apple Pay | Instant',
    subtitle: 'Pay using Apple Pay',
    icon: ApplePaySVG,
  },

  // 4. Rapid Bank Transfer
  {
    id: 'skrill_rapid',
    settingsKey: 'skrill_rapid',
    label: 'Rapid - Bank Transfer | Instant',
    subtitle: 'Instant Bank Transfer powered by Rapid',
    icon: RapidOptionIcon,
    maxAmountEur: 5000,
  },

  // 5. Manual Bank Transfer
  {
    id: 'micropayment_prepay',
    settingsKey: 'micropayment_prepay',
    label: 'Manual - Bank Transfer | 2-7 Days',
    subtitle: 'Manual - Bank Transfer',
    icon: {type: 'image', src: '/media/icons/duotune/finance/icon-prepay-en.svg', className: 'w-40px me-3'},
  },

  // 6. Onlineüberweisung (Sofort)
  {
    id: 'micropayment_sofort',
    settingsKey: 'micropayment_sofort',
    label: 'Onlineüberweisung - Online Banking | Instant',
    subtitle: 'Onlineüberweisung - Online Bank Transfer',
    icon: {type: 'image', src: '/media/icons/duotune/finance/onlnuebwsng_icon.png', className: 'w-40px me-3'},
    maxAmountEur: 4999,
  },

  // 7. Binance Pay
  {
    id: 'bpay',
    settingsKey: 'bpay',
    label: 'Binance Pay | Instant',
    subtitle: 'Pay using your Binance account',
    icon: BpaySVG,
  },

  // 8. Volet (Advcash)
  {
    id: 'advcash',
    settingsKey: 'advcash',
    label: 'Volet | Instant',
    subtitle: 'Pay using your Volet Wallet',
    icon: AdvcashSVG,
  },

  // 9. Skrill
  {
    id: 'skrill',
    settingsKey: 'skrill',
    label: 'Skrill | Instant',
    subtitle: 'Pay using your Skrill Account',
    icon: SkrillOptionIcon,
  },

  // 10. Neteller
  {
    id: 'skrill_neteller',
    settingsKey: 'skrill_neteller',
    label: 'Neteller | Instant',
    subtitle: 'Pay using your Neteller Account',
    icon: NetellerOptionIcon,
    maxAmountEur: 10000,
  },

  // 11. Trustly (requires external availability check)
  {
    id: 'trustly',
    settingsKey: 'reap_cc',
    label: 'Trustly',
    subtitle: 'Trustly',
    icon: {type: 'image', src: '/media/card-logos/trustly.png', className: 'w-40px me-3'},
    requiresExternalCheck: true,
  },

  // 12. Klarna
  {
    id: 'klarna',
    settingsKey: 'klarna',
    label: 'Klarna | Ratenzahlung',
    subtitle: 'Pay in installments with Klarna',
    icon: {type: 'image', src: 'https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg', className: 'w-40px me-3'},
  },
]
